import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useCallback, useMemo } from 'react';
import { ChevronUpSmall } from '@indriver/mireska';
import { Transition } from 'react-transition-group';
import { useAccordionAnimation } from '@indriver/nova-core';
import { useComponentId } from '@indriver/whisperwind';
import { Box, Cell, Chevron, AccordionBox } from './accordion.styles.js';

var _ChevronUpSmall;

var _excluded = ["children", "opened", "label", "onClick", "dir"];
var Accordion = function Accordion(props) {
  var children = props.children,
      _props$opened = props.opened,
      opened = _props$opened === void 0 ? false : _props$opened,
      label = props.label,
      onClick = props.onClick,
      dir = props.dir,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var id = useComponentId({
    prefix: 'accordion'
  });
  var boxRef = useRef(null);

  var _useAccordionAnimatio = useAccordionAnimation(boxRef),
      boxHeight = _useAccordionAnimatio.boxHeight,
      handleExiting = _useAccordionAnimatio.handleExiting,
      handleEntering = _useAccordionAnimatio.handleEntering;

  var handleClick = useCallback(function () {
    if (typeof onClick === 'function') {
      onClick();
    }
  }, [onClick]);
  var ariaAttrs = useMemo(function () {
    var arias = {};

    if (opened) {
      arias['aria-expanded'] = opened;
    }

    if (id) {
      arias['aria-controls'] = id;
    }

    if (label) {
      arias['aria-label'] = label;
    }

    return arias;
  }, [opened, label, id]);
  return /*#__PURE__*/React__default.createElement(Box, {
    dir: dir
  }, /*#__PURE__*/React__default.createElement(Cell, _extends({}, attrs, {
    onClick: handleClick
  }, ariaAttrs), label, /*#__PURE__*/React__default.createElement(Chevron, {
    opened: opened,
    "aria-hidden": true
  }, _ChevronUpSmall || (_ChevronUpSmall = /*#__PURE__*/React__default.createElement(ChevronUpSmall, {
    size: 24
  })))), /*#__PURE__*/React__default.createElement(Transition, {
    in: opened,
    timeout: 300,
    unmountOnExit: true,
    appear: true,
    onExiting: handleExiting,
    onEntering: handleEntering
  }, function (state) {
    return state !== 'exited' ? /*#__PURE__*/React__default.createElement(AccordionBox, {
      boxHeight: boxHeight,
      ref: boxRef,
      id: id
    }, children) : null;
  }));
};

export { Accordion };
